/*
 * @Copyright: @ Silk Software Corp. All Rights Reserved Based on MIT-LICENSE
 */
import { gql } from '@apollo/client'

export const GET_DASHBOARD_COMPANIES = gql`
  query getSuperAdminCompanies(
    $superAdminId: Int!
    $search: String
    $orderBy: String
  ) {
    superAdminCompanies(
      superAdminId: $superAdminId
      search: $search
      orderBy: $orderBy
    ) {
      edges {
        node {
          companyId
          id
          companyName
          bcGroupName
          companyAdminName
          companyEmail
          extraFields {
            fieldName
            fieldValue
          }
        }
      }
      totalCount
    }
  }
`
